import React, { useState } from 'react'
import { Link } from 'gatsby'

import styled from 'styled-components'

const StyledFooter = styled.footer`
  align-content: center;
  padding: 100px 100px;
  @media (max-width: 700px) {
    padding: 40px 20px;
  }
  background: linear-gradient(96.64deg, #061621 0%, #21373C 99.64%);
  color: white;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding-bottom: 40px;
`

const FooterContent = styled.div`
  margin: 20px 20px;
  max-width: 540px;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  p.copyright {
    font-size: 14px;
  }
  .logoSection {
    align-content: space-between;
  }
  .disabled {
    border-color: #65737e;
    color: rgb(184, 196, 194);
    background-color: rgb(93, 108, 116);
    cursor: not-allowed;
  }
`

const ContentContainer = styled.div`
  width: full;
  max-width: 1160px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin: -20px 0px;
  p {
    color: #9FA1A2
  }
`

const StyledInput = styled.input`
  padding: 13px 15px;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #E7EEEC;
  font-size: 16px;
  line-height: 19px;
  max-width: 260px;
  width: 100%;
  box-sizing: border-box;
  height: 50px;
`

const LineBreak = styled.div`
  width: 100%;
  height: 1px;
  max-width: 1160px;
  background: transparent;
  border-top: 1px solid #273359;
  margin: 100px auto 40px;
`

const StyledButton = styled.button`
  color: #6E60F9;
  padding: 13px 15px;
  background-color: transparent;
  cursor: pointer;
  border-radius: 8px;
  font-size: 16px;
  border: 2px solid #6E60F9;
  font-family: effra-bold;
  margin-left: 10px;
  box-sizing: border-box;
  height: 50px;
`

const RealmLogo = styled.img`
  width: 80px;
`

const LinkSection = styled.div`
  width: 110px;
  h4 {
    color: white;
    font-size: 16px;
  }
  a {
    color: #9FA1A2;
    font-size: 14px;
  }
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

const LinkSectionSubContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

const LinkSectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`

const Footer = () => {
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [submissionMessage, setSubmissionMessage] = useState('')
  const GUID = () => {
    if (typeof window.GetElqCustomerGUID === 'function') {
      return window.GetElqCustomerGUID()
    }
    return ''
  }
  

  const handleFormSubmit = (e) => {
    e.preventDefault()
    setButtonDisabled(true)
    const clearbitData = window.clearbit ? window.clearbit.profile() : {}
    const sessionData = window.userSession ? window.userSession.get() : {}
    const email = e.target.email.value
    window.fetch('/api/subscribe', {
      method: 'POST',
      body: JSON.stringify({
        email,
        elqCustomerGUID: GUID(),
        anonymousId: window.segment ? window.segment.anonymousId() : '',
        gtm_loaded: window.gtm_loaded || false,
        url: window.location.href,
        web_check_businessemail: window.segment
          ? window.segment.isBusinessEmail(email)
          : false,
        gtm_loaded: window.gtm_loaded || false,
        segment_loaded: window.sessionStorage.getItem('segmentLoaded') === 'true',
        adblock_enabled:
          window.sessionStorage.getItem('adblockEnabled') === 'true',
        country: window.clearbit ? window.clearbit.countryCode() : '',
        ...clearbitData,
        ...sessionData
      })
    })
    setTimeout(() => {
      setSubmissionMessage('Thank you for subscribing!')
      setFormSubmitted(true)
    }, 500)
    // if (response.ok) {
    //   setSubmissionMessage('Thank you for subscribing!')
    // } else {
    //   setSubmissionMessage('Something went wrong, please try again')
    // }
    // setFormSubmitted(true)
  }

  return (
    <StyledFooter>
      <ContentContainer>
        <FooterContent>
          <h3>Get Started with Realm</h3>
          <p>Available for Swift, Objective-C, Java, Kotlin, C#, and JavaScript.</p>
          <a href='https://docs.mongodb.com/realm/get-started/introduction-mobile'>Get Started →</a>
        </FooterContent>
        <FooterContent>
          <h3 id='realm-signup'>Stay updated</h3>
          <p>Realm’s newsletter keeps you up to date on product announcements, best practices, community events, and more.</p>
          <form
            onSubmit={handleFormSubmit}
            style={{
              display: formSubmitted ? 'none' : 'flex',
              flexDirection: 'row'
            }}
          >
            <StyledInput
              required
              placeholder='Email'
              type='email'
              id='email'
              autocomplete='email'
            />
            <StyledButton id='subscribe' className={buttonDisabled ? 'disabled' : ''}>Subscribe</StyledButton>
          </form>
          <h4
            style={{
              display: formSubmitted ? 'block' : 'none'
            }}
          >
            {submissionMessage}
          </h4>
        </FooterContent>
      </ContentContainer>
      <LineBreak />
      <ContentContainer style={{flexWrap: 'wrap-reverse'}}>
        <FooterContent style={{alignContent: 'space-between'}}>
          <RealmLogo src='https://webassets.mongodb.com/_com_assets/cms/realm_logo_compressed-9w1h3quhi5.png' />
          <p className='copyright'>© 2020 Realm</p>
        </FooterContent>
        <FooterContent>
          <LinkSectionContainer>
            <LinkSectionSubContainer>
              <LinkSection>
                <h4>Realm</h4>
                <a href='https://github.com/realm' target='_blank' rel='noopener noreferrer'>Realm GitHub</a>
                <a href='https://twitter.com/realm' target='_blank' rel='noopener noreferrer'>Realm Twitter</a>
                <a href='https://docs.mongodb.com/realm/sdk' target='_blank' rel='noopener noreferrer'>Realm Docs</a>
              </LinkSection>
              <LinkSection>
                <a href='https://developer.mongodb.com/learn/?content=Articles&products=Mobile#main' target='_blank' rel='noopener noreferrer'>Blog</a>
                <Link to='/release-notes'>Releases</Link>
                <Link to='/community'>Community</Link>
              </LinkSection>
            </LinkSectionSubContainer>
            <LinkSectionSubContainer>
              <LinkSection>
                <h4>MongoDB</h4>
                <a href='https://www.mongodb.com/realm' target='_blank' rel='noopener noreferrer'>MongoDB Realm</a>
                <a href='https://www.mongodb.com/realm/mobile/sync' target='_blank' rel='noopener noreferrer'>Realm Sync</a>
                <a href='https://www.mongodb.com/legal/legal-notices' target='_blank' rel='noopener noreferrer'>Legal Notices</a>
              </LinkSection>
              <LinkSection>
                <a href='https://www.mongodb.com/legal/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy Notices</a>
                <a href='https://www.mongodb.com/community-code-of-conduct' target='_blank' rel='noopener noreferrer'>Code of Conduct</a>
                <a href='https://www.mongodb.com/careers' target='_blank' rel='noopener noreferrer'>Careers</a>
              </LinkSection>
            </LinkSectionSubContainer>
          </LinkSectionContainer>
        </FooterContent>
      </ContentContainer>
    </StyledFooter>
  )
}

export default Footer
